import { render } from "./RuleSelector.vue?vue&type=template&id=6768c971&scoped=true"
import script from "./RuleSelector.vue?vue&type=script&lang=js"
export * from "./RuleSelector.vue?vue&type=script&lang=js"

import "./RuleSelector.vue?vue&type=style&index=0&id=6768c971&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6768c971"]])

export default __exports__